import styled from "styled-components";

interface ContainerSidebarNavProps {
  paddingTop?: string;
}

export const ContainerSidebarNav = styled.div<ContainerSidebarNavProps>`
  display: flex;
  flex-direction: column;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: ${({ paddingTop }) => (paddingTop ? paddingTop : "")};
  height: 100%;
  width: 100%;
  padding-bottom: 8rem;
  background-color: #f5f6fa;
`;

export const SubContainerSideBarNav = styled.div`
  height: 80%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ListDocumentsContainer = styled.div``;

export const ModalContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
`;

export const ContainerVariables = styled.div`
  width: 40%;
  height: 80%;
  padding: 3.5rem;
  background-color: #fff;
  border-radius: 10px;
  overflow-y: auto;
`;

export const ContainerModalDocumentName = styled.div`
  background-color: #fff;
  border-radius: 30;
  width: 30%;
  border: 1px solid #c4c4c4;
  border-radius: 10px;
  padding: 3rem 3.5rem;
`;

export const ContainerLoading = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const LabelDocumentName = styled.label`
  color: #343a40;
  font-size: 1.4rem;
  font-family: "Roboto";
`;

export const ContainerButtonsYesNo = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
`;

export const NoVariables = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-weight: 600;
`;

export const NoVariablesLabel = styled.label`
  font-size: 12pt;
  text-align: center;
`;
